<template>
    <div class="report__show">
        <div class="report__show_header">
            <view-actions
                :title="`${toCapitalize(reportType)} ${this.$t('ebs.reports.title.reportView')}`"
                :action-button-active="false"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: this.$t('ebs.reports.title.reports'),
                        to: { name: 'ebs-report-dashboard' }
                    }
                ]"
            />
        </div>
        <div class="report__show_main">
            <div class="container">
                <base-report
                    :report-type="reportType"
                    :get-filters-getter="'getReportGeneratedReportFilters'"
                    :get-filters-dispatch="'getReportGeneratedReportFilters'"
                    :get-filters-fetch-dispatch="'getReportFetchReportFilters'"
                    :set-filters-fetch-dispatch="'setReportFetchReportFilters'"
                    :get-data-getter="'getReportGeneratedReportData'"
                    :get-data-dispatch="'getReportGeneratedReportTable'"
                    :get-pagination-getter="'getReportGeneratedReportPagination'"
                    :get-report-table-dispatch="'getReportGeneratedReportTable'"
                    :get-report-csv-dispatch="'getReportGeneratedReportCSV'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BaseReport from '@/components/ebs/reports/BaseReport'
import ViewActions from '@/components/default/shared/ViewActions'

export default {
  name: 'report-show',
  components: { ViewActions, BaseReport },
  computed: {
    reportType () {
      return this.$route.params.slug
    }
  }
}
</script>
<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/reportshow";
</style>
